import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ISideNavSliderProps } from '../components/side-nav-slider/side-nav-slider';
import { ISideNavSliderItemProps } from '../components/side-nav-slider/side-nav-slider-item/side-nav-slider-item';
import { SideNavSliderItemModel } from './side-nav-item-slider-model';

export class SideNavSliderModel extends ContentItem {
  get navItems(): ISideNavSliderItemProps[] {
    const getNavItems = get(this._config, 'elements.nav_items.value', null);

    const transformNavTabs = getNavItems
      ? getNavItems.map((navTab: ISideNavSliderItem) =>
          SideNavSliderItemModel.create(navTab)
        )
      : null;
    return transformNavTabs;
  }

  get content(): IKontentItem[] {
    return get(this._config, 'elements.content_items.value', []);
  }

  get header(): string {
    return get(this._config, 'elements.header_value.value', '');
  }

  get headerPosition(): string {
    return get(this._config, 'elements.header_position.value[0].codename', '');
  }

  public static create(data: ISideNavSlider): ISideNavSliderProps {
    const {
      navItems,
      header,
      headerPosition,
      content
    } = new SideNavSliderModel(data);
    return {
      navItems,
      content,
      headerPosition,
      header
    };
  }
}
